import { createContext } from 'react';

const JourneyConfig = createContext();

export default JourneyConfig;
